var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"logoContainer",staticClass:"logo-animation"},_vm._l((this.imageNum),function(images,index){return _c('div',{key:index,staticClass:"logo"},[_c('img',{class:'logo-' + (index + 1),attrs:{"src":_vm.newImages[_vm.currentImages[index]]}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98b814f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoAnimation.vue
// module id = null
// module chunks = 